export default __webpack_public_path__ + "static/media/DP4 4B-2EC.79e6028c.jpg";